import {all} from 'redux-saga/effects';
import authSaga from './auth'
import cartSaga from './cart'
import categorySaga from './category'
import imageSaga from './image'
import loyaltySaga from './loyalty'
import menuSaga from './menu'
import orderSaga from './order'
import reportSaga from './report'
import paymentSaga from './payment'
import searchresultsSaga from './searchresults'
import settingsSaga from './settings'
import superUserSaga from './superuser'
import tableSaga from './table'
import userSaga from './user'
import venueSaga from './venue'


export default function* rootSaga() {
    yield all([
        authSaga(),
        cartSaga(),
        categorySaga(),
        imageSaga(),
        loyaltySaga(),
        menuSaga(),
        searchresultsSaga(),
        reportSaga(),
        paymentSaga(),
        settingsSaga(),
        superUserSaga(),
        orderSaga(),
        tableSaga(),
        userSaga(),
        venueSaga()
    ]);
}